module.exports = __webpack_public_path__ + "static/img/Parametric Studies 6 - Scripting.53a6de7.png";